import React from "react";
import "./TechnicalConsultantInfo.scss";

type TechnicalConsultantInfoProps = {
  name?: string;
  className?: string;
};

const TechnicalConsultantInfo: React.FC<TechnicalConsultantInfoProps> = ({
  name,
  className = "",
}) => {
  const trimmed = name?.trim();
  if (!trimmed || trimmed === "-") {
    return null;
  }

  return (
    <div className={`technical-consultant-info ${className}`.trim()}>
      <span className="technical-consultant-info__label">Technical Consultant</span>
      <span className="technical-consultant-info__name">{trimmed}</span>
    </div>
  );
};

export default TechnicalConsultantInfo;
